<template>
  <div class="container">
    <Header />
    <FullMap
      v-if="curMap == 1 && MapData"
      title=""
      legendTop="57%"
      :areaCode="MapData.areaCode"
      :mapData="MapData.mapData"
      :legendConf="MapData.legendConf"
      :itemList="MapData.itemList"
    />
    <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>

    <div class="left-content">
      <BScroll>
        <div>
          <BasePanel code="104" title="7月游客量概况">
            <YoukeliangGaikuang
              :chartData="YoukeliangGaikuangData"
              v-if="YoukeliangGaikuangData"
            />
          </BasePanel>
          <BasePanel title="游客来源分析" url="/home/youkelaiyuan">
            <YoukeLaiyuanFenxi
              :chartData="youkelaiyuanData"
              v-if="youkelaiyuanData.length > 0"
            />
          </BasePanel>
          <BasePanel title="省内游客热门路线" url="home/shengneiremenluxian">
            <YoukeRemenLuxian
              :chartData="youkeremenluxianData"
              v-if="youkeremenluxianData.length > 0"
            />
          </BasePanel></div
      ></BScroll>
    </div>
    <div class="right-content">
      <BScroll
        ><div>
          <BasePanel code="101" title="游客群体画像">
            <YoukeQuntiHuaxiang />
          </BasePanel>
          <BasePanel code="102" title="游客线下行为分析">
            <YoukeXianxiaXingweiFenxi />
          </BasePanel>
          <BasePanel code="103" title="游客线上行为分析">
            <YoukeXianshangXingweiFenxi />
          </BasePanel></div
      ></BScroll>
    </div>
    <div
      class="center-top-content"
      :class="['center-top-content', { 'click-chuantou': curMap == 1 }]"
    >
      <BtMap
        v-if="curMap == 0 && MapData"
        :mapData="MapData.mapData"
        :areaCode="MapData.areaCode"
        :legendConf="MapData.legendConf"
        :itemList="MapData.itemList"
      />
    </div>
    <div class="center-bottom-content">
      <HomeBottomBar
        id="homeBottomBar"
        :chartData="homebottombarData"
        v-if="homebottombarData"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Common/Header.vue";
import MapTitle from '@/components/Common/MapTitle.vue'
import BtMap from "@/components/BorderMapComponent/index.vue";
import BasePanel from "@/components/Common/BasePanel.vue";
import YoukeliangGaikuang from "@/components/Home/YoukeliangGaikuang.vue";
import YoukeLaiyuanFenxi from "@/components/Home/YoukeLaiyuanFenxi.vue";
import YoukeRemenLuxian from "@/components/Home/YoukeRemenLuxian.vue";
import YoukeXianshangXingweiFenxi from "@/components/Home/YoukeXianshangXingweiFenxi.vue";
import YoukeXianxiaXingweiFenxi from "@/components/Home/YoukeXianxiaXingweiFenxi.vue";
import YoukeQuntiHuaxiang from "@/components/Home/YoukeQuntiHuaxiang.vue";
import HomeBottomBar from "@/components/Echarts/HomeBottomBar.vue";
import FullMap from "@/components/FullMap.vue";

import BScroll from "@/components/Common/BScroll.vue";

export default {
  name: "Home",
  components: {
    Header,
    MapTitle,
    BtMap,
    BasePanel,
    YoukeliangGaikuang,
    YoukeLaiyuanFenxi,
    YoukeRemenLuxian,
    YoukeXianshangXingweiFenxi,
    YoukeXianxiaXingweiFenxi,
    YoukeQuntiHuaxiang,
    HomeBottomBar,
    FullMap,
    BScroll
  },
  data() {
    return {
      mapTitleData: {
        title: '',
        tab: ['立体地图', '平面地图']
      },
      curMap: 0,
      MapData: null,
      YoukeliangGaikuangData: null,
      youkelaiyuanData: [],
      youkeremenluxianData: [],
      homebottombarData: null
    };
  },
  mounted() {
    // 请求地图数据
    fetch("/data/Home/MapData.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.MapData = json.data;
        this.mapTitleData.title = json.data.title;
      });
    // 请求游客量概况
    fetch("/data/Home/YoukeliangGaikuang.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.YoukeliangGaikuangData = json.data;
      });
    // 请求游客来源
    fetch("/data/Home/YoukeLaiyuan.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.youkelaiyuanData = json.data;
      });
    // 请求热门路线
    fetch("/data/Home/YoukeRemenLuxian.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.youkeremenluxianData = json.data;
      });
    // 请求底部图表
    fetch("/data/Home/HomeBottomBar.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.homebottombarData = json.data;
      });
  },
  methods: {
    setCurtab(val) {
      this.curMap = val
    }
  }
};
</script>
<style scoped lang="less">
.center-content {
  width: 56%;
  height: 89%;
  max-height: 1080px;
  position: absolute;
  top: 1.04rem;
  left: 50%;
  transform: translateX(-50%);
  .center-top-content {
    width: 100%;
    height: 78%;
    position: relative;
  }
  .center-bottom-content {
    width: 100%;
    height: 22%;
  }
}
.center-top-content {
  width: 56%;
  height: 65%;
  position: relative;
  margin: 0 auto;
}
.center-bottom-content {
  width: 56%;
  height: 22%;
  margin: 0 auto;
}
.click-chuantou {
  pointer-events: none;
}
</style>
